// Utilities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import {
  dailyReportService, // Importing the service for making API requests related to daily reports
} from "../../../Api/Services/DailyReportService";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";
import { IGetDailyReportService } from "../../../Types/DailyReport";

/**
 * Async thunk to fetch daily report list.
 * Dispatches an API call to retrieve the daily report list.
 */
export const fetchDailyReporListAsyncThunk = createServiceAsyncThunk<
  IGetDailyReportService, // Response Type
  { id?: string } // Payload Type
>(
  ACTION_NAMES.FETCH_DAILY_REPORT_LIST, // Action Name
  ({ id }) => dailyReportService.getDailyReport(id), // API Call
  ERROR_MESSAGES.DAILY_REPORT_LIST_FETCH_FAILURE // Error Message
);

/**
 * Slice to manage the state of daily report list.
 * Includes actions to clear errors and handle async states.
 */
const dailyReportListSlice = createGenericSlice<
  IGetDailyReportService,
  { id?: string }
>(
  SLICE_NAMES.DAILY_REPORT_LIST, // Slice Name
  fetchDailyReporListAsyncThunk // Async Thunk
);

// Export the actions to be dispatched in components
export const { clearError: clearDailyReportListError } =
  dailyReportListSlice.actions;

// Export the reducer to be used in the store
export default dailyReportListSlice.reducer;
